 <form>
  <section class="content">
    <div class="row">
      <div class="col-sm-10 col-sm-offset-1">

        <div class="box box-primary">
          <div class="box" style="border-top:0px !important">
            <div class="box-body">

              <div class="box ibox box-info">
                <div class="box-body">

                  <section class="content-header">
                    <h1 class="text-center">Document Library</h1>
                  </section>

                  <div class="col-sm-12 box-row">

                    <section class="box-header with-border mt-4">

                      <p-accordion [multiple]="true" (onOpen)="onTabOpen($event)">

                        <p-accordionTab
                          *ngFor="let tab of accordionTabs; let i=index"
                          [selected]="!tab.collapsed">

                          <!-- HEADER -->
                            <ng-template pTemplate="header">
                            <div style="display:flex; align-items:center; justify-content:space-between; width:100%;">
                              <h3 class="box-title" style="margin:0;">
                                {{ tab.title }}
                              </h3>

                              <div (click)="$event.stopPropagation()">
                                <input type="file"
                                       class="FileInput hidden"
                                       [id]="uploadID + '_' + tab.id"
                                       ng2FileSelect
                                       [uploader]="uploader"
                                       multiple />

                                <button class="btn btn-success btn-xs padding2"
                                        type="button" style="padding:5px;"
                                        (click)="UploadFiles(tab)">
                                  <i class="glyphicon glyphicon-upload"></i>
                                  &nbsp; Upload File
                                </button>
                              </div>
                            </div>
                          </ng-template>

                          <!-- DOCUMENTS -->
                   <div class="doc-container" *ngIf="tab.loaded">

  <!-- Static Documents -->
  <div *ngIf="tab.staticDocuments.length > 0" class="doc-section">
    <h4><strong>BMR Docs</strong></h4>

    <div class="doc-grid">
      <div class="doc-card"
           *ngFor="let doc of tab.staticDocuments"
           (click)="openImageDialog('document-library',
           setCategorywithFileName(doc.fileName),
           doc.fileLabel)">

          <i class="fa"
            [ngClass]="getFileIcon(doc.fileName).icon + ' ' + getFileIcon(doc.fileName).class">
          </i>

        <div class="doc-name" [title]="doc.fileLabel">
          {{ doc.fileLabel }}
        </div>
      </div>
    </div>
  </div>
  <!-- Dynamic Documents -->
  <div *ngIf="tab.dynamicDocuments.length > 0" class="doc-section" style="margin-top: 30px !important;">
    <h4><strong>User Docs</strong></h4>

    <div class="doc-grid">
      <div class="doc-card"
           *ngFor="let doc of tab.dynamicDocuments"
           (click)="openImageDialog('document-library',
           setCategorywithFileName(doc.fileName),
           doc.fileLabel)">

        <i class="fa"
          [ngClass]="getFileIcon(doc.fileName).icon + ' ' + getFileIcon(doc.fileName).class">
        </i>
        <div class="doc-name" [title]="doc.fileLabel">
          {{ doc.fileLabel }}
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="tab.staticDocuments.length === 0 && tab.dynamicDocuments.length === 0"
       class="no-documents">
    No documents available
  </div>

</div>
                        </p-accordionTab>
                      </p-accordion>

                    </section>

                  </div>

                </div>
              </div>

            </div>
          </div>
        </div>

      </div>
    </div>
  </section>
</form>
